import React, {useState} from 'react';



export const Carousel = () => {
	
  return (
  
  <>
    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
  <ol className="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img className="d-block w-100" src="screenprinting-slide.png" alt="First slide"
	  />
	  <div className="carousel-caption d-none d-md-block" >
    <h1 className="font-weight-bold text-white bg-dark">Screenprint your design</h1>
  </div>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="dtg-slide.png" alt="Second slide"
	  />
	  <div className="carousel-caption d-none d-md-block" >
    <h1 className="font-weight-bold text-white bg-dark">Direct-to-Garment printing for more complex art</h1>
  </div>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="embroidery-slide.png" alt="Third slide"
	  />
	  <div className="carousel-caption d-none d-md-block " >
	  
    <h1 className="font-weight-bold text-white bg-dark">Embroidered designs on polos and hats</h1>
  </div>
    </div>
  </div>

  <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="sr-only">Previous</span>
  </a>
  <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="sr-only">Next</span>
  </a>
</div>

<br></br>
<button type="button" className="btn btn-primary btn-lg btn-radius" id="design-btn">Start Designing</button>
<br></br>
<br></br>

  </>
  );
};

